/** @format */

import React, { FunctionComponent, ReactElement, useEffect, useState } from 'react';
import SimCardInterface from '../../../interfaces/platform/SimCardInterface';
import GridContainer from '../../../components/Grid/GridContainer';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import I18n from '../../../components/Translate/I18n';
import GridItem from '../../../components/Grid/GridItem';
import ActionButton from '../../../components/Buttons/CustomTextButton';
import { useDispatch } from 'react-redux';
import { ItemLoaders } from '../../../core/loaders/ItemLoaders';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import { SimpleSelect } from '../../../components/Adescom/SimpleSelect';
import ChooseIpButton from '../../../components/Buttons/CustomTextButton';
import IpPoolDialog from '../../ip-pools/mvno/IpPoolDialog';
import PlatformIpPoolNumber from '../../../interfaces/platform/PlatformIpPoolNumber';
import MvnoBlockRequest from '../../../interfaces/platform/MvnoBlockRequest';
import { AlertDialog } from '../../lib/dialog/AlertDialog';
import { ApiCollectionInterface } from '../../../interfaces/collections/ApiCollectionInterface';
import { ApnNameInterface } from '../../../interfaces/collections/ApnNameInterface';
import { HeaderCheckBoxSelectListElement } from '../../lib/search/listTableHeader/HeaderCheckBoxSelectList';
import { configDefault } from '../../../core/config';
import i18n from '../../../core/i18n';
import PlatformResellerInterface from '../../../interfaces/platform/PlatformResellerInterface';

type ProductOplChangeApnType = {
    product: SimCardInterface;
    platformReseller: PlatformResellerInterface;
    refreshPage: () => void;
};

export const ProductOplChangeApn: FunctionComponent<ProductOplChangeApnType> = ({ product, refreshPage, platformReseller }): ReactElement => {
    const dispatch = useDispatch();
    const [ipEnable, setIpEnable] = useState(product.ipEnable);
    const [saveButton, setSaveButton] = useState(false);
    const [ipDialog, setIpDialog] = useState(false);
    const [alert, setAlert] = useState<any | null>(null);
    const [apnName, setApnName] = useState<string | null>(product.ipApnName);
    const [ip, setIp] = useState<string | null>(null);
    const [publicApnName, setPublicApnName] = useState<Array<HeaderCheckBoxSelectListElement> | null>(null);
    const [privateApnName, setPrivateApnName] = useState<Array<HeaderCheckBoxSelectListElement> | null>(null);
    const [apnNameList, setApnNameList] = useState<Array<HeaderCheckBoxSelectListElement> | null>(null);
    const [apnNameId, setApnNameId] = useState<number | null>(null);

    // useEffect(() => {
    //     if (apnNameId !== product.apnNameId) {
    //         setApnNameId(product.apnNameId);
    //         setApnNameList(null);
    //         setPrivateApnName(null);
    //         setApnName(product.ipApnName);
    //     }
    // }, [product, apnNameId]);

    useEffect(() => {
        if (platformReseller && publicApnName === null) {
            const itemLoader = new ItemLoaders(dispatch);
            itemLoader.getListWithCallback(
                FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/apn_names', configDefault.PLATFORM_API_PREFIX)),
                'platform-reseller-apn-name-public-list',
                [
                    { name: 'isDeleted', value: false },
                    { name: 'isPublic', value: true },
                ],
                [{ name: 'apnName', value: 'asc' }],
                (data: ApiCollectionInterface<ApnNameInterface>): void => {
                    const tmp: Array<HeaderCheckBoxSelectListElement> = [];
                    data['hydra:member'].map((data): void => {
                        tmp.push({ value: data.id, name: data.apnName + i18n.t('pools:apn.public'), hiddenName: data.apnName });
                    });
                    setPublicApnName(tmp);
                },
                { dispatchAfterCallback: false, propagateDataToCallback: true }
            );
        }
    }, [platformReseller, dispatch, publicApnName]);

    useEffect(() => {
        if (platformReseller && privateApnName === null) {
            const itemLoader = new ItemLoaders(dispatch);
            itemLoader.getListWithCallback(
                FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/apn_names', configDefault.PLATFORM_API_PREFIX)),
                'platform-reseller-apn-name-public-list',
                [
                    { name: 'isDeleted', value: false },
                    { name: 'isPublic', value: false },
                    { name: 'platformReseller', value: platformReseller.id },
                ],
                [{ name: 'apnName', value: 'asc' }],
                (data: ApiCollectionInterface<ApnNameInterface>): void => {
                    const tmp: Array<HeaderCheckBoxSelectListElement> = [];
                    data['hydra:member'].map((data): void => {
                        tmp.push({ value: data.id, name: data.apnName + i18n.t('pools:apn.private'), hiddenName: data.apnName });
                    });
                    setPrivateApnName(tmp);
                },
                { dispatchAfterCallback: false, propagateDataToCallback: true }
            );
        }
    }, [platformReseller, dispatch, privateApnName]);

    useEffect(() => {
        if (publicApnName && privateApnName && apnNameList === null) {
            setApnNameList([...publicApnName, ...privateApnName]);
        }
    }, [privateApnName, publicApnName, apnNameList]);

    const onCheckBoxEvent = (event: React.ChangeEvent<HTMLInputElement>): void => {
        const name = event.target.name;
        const value = event.target.value;
        const checked = event.target.checked;
        setIpEnable(checked);
        if (product.ipEnable !== checked) {
            setSaveButton(true);
        } else {
            setSaveButton(false);
        }
    };

    const callback = (event: React.ChangeEvent<HTMLSelectElement>): void => {
        const name = event.target.name;
        const value = event.target.value;
        setApnNameId(parseInt(value));
        if (apnNameList) {
            apnNameList.map((item): void => {
                if (item.value === parseInt(value)) {
                    setApnName(item.hiddenName ?? '');
                    return;
                }
            });
        }
    };

    const callBackSetIp = (v: { isPrivate: boolean; item: PlatformIpPoolNumber; uri: string } | null): void => {
        if (v) {
            setIp(v.item.ip);
        } else {
            setIp(null);
        }
        setIpDialog(false);
    };

    const activateFeatureConfirm = (): void =>
        setAlert(
            <AlertDialog
                open={!alert}
                titleDialog="simcard:apnOpl.apn"
                displayMessage="simcard:apnOpl.confirm_activate_deactivate_apn"
                closeCallback={(): void => setAlert(null)}
                confirmCallback={activateCallApi}
            />
        );

    const activateCallApi = (): void => {
        if (ipEnable && apnName === null) {
            return;
        }
        const itemLoader = new ItemLoaders(dispatch);
        let status = 0;
        if (ipEnable) {
            status = 1;
        }
        itemLoader.postWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/operation_change_apns')),
            'operation_manage_apn_on_off',
            {
                operation: status,
                simCardId: product.id,
                apnName: status === 1 ? apnName : null,
                qosp: status === 1 ? 1 : null,
                ip: status === 1 ? ip : null,
                ipType: status === 1 ? 'IPv4' : null,
            },
            (response: MvnoBlockRequest) => {
                setAlert(null);
                refreshPage();
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    };

    if (product.apnNameId && product.ipApnName === null) {
        return (
            <GridContainer>
                <GridItem xs={12}>
                    <I18n trans="pools:apn.apn_activation_in_progress" />
                </GridItem>
            </GridContainer>
        );
    }

    return (
        <GridContainer>
            {apnNameList && (
                <React.Fragment>
                    <GridItem xs={12}>
                        <FormControlLabel
                            control={<Switch checked={ipEnable} onChange={onCheckBoxEvent} value="premiumLimitSingleSwitch" />}
                            label={<I18n trans="simcard:apnOpl.apn" />}
                        />
                    </GridItem>
                    {ipEnable && !saveButton && (
                        <React.Fragment>
                            {product.ipPublic && (
                                <GridItem xs={12}>
                                    <I18n trans="simcard:apnOpl.ip" valueObject={{ ip: product.ipPublic }} />
                                </GridItem>
                            )}
                            {product.ipPrivate && (
                                <GridItem xs={12}>
                                    <I18n trans="simcard:apnOpl.ip" valueObject={{ ip: product.ipPrivate }} />
                                </GridItem>
                            )}
                            <GridItem xs={12}>
                                <I18n trans="simcard:apnOpl.ip_type" valueObject={{ ip_type: product.ipType }} />
                            </GridItem>
                            <GridItem xs={12}>
                                <I18n trans="simcard:apnOpl.apn_name" valueObject={{ apn_name: product.ipApnName }} />
                            </GridItem>
                            <GridItem xs={12}>
                                <I18n trans="simcard:apnOpl.qosp" valueObject={{ qosp: product.ipQosp }} />
                            </GridItem>
                        </React.Fragment>
                    )}
                    {ipEnable && saveButton && (
                        <React.Fragment>
                            <GridItem xs={12}>
                                <SimpleSelect
                                    label="simcard:apn.apn_name"
                                    required={true}
                                    elements={apnNameList ?? []}
                                    dispatchName={'no-dispatch'}
                                    selectedValue={apnNameId}
                                    callback={callback}
                                    fieldName="apnName"
                                />
                            </GridItem>
                            <GridItem xs={12}>
                                <I18n trans="simcard:apnOpl.ip" valueObject={{ ip: ip }} />
                            </GridItem>
                        </React.Fragment>
                    )}
                    {saveButton && (
                        <GridItem xs={12}>
                            {saveButton && ipEnable && apnNameId && (
                                <ChooseIpButton
                                    callback={(): void => setIpDialog(true)}
                                    callbackParam={{}}
                                    label="simcard:apn.choose_ip_address"
                                    size="sm"
                                />
                            )}
                            <ActionButton
                                callback={activateFeatureConfirm}
                                callbackParam={{}}
                                label={product.platformIpPoolNumberId ? 'simcard:apn.disable_apn' : 'simcard:apn.setup_new_apn'}
                                size="sm"
                            />
                            {alert}
                        </GridItem>
                    )}
                </React.Fragment>
            )}
            {apnNameId && apnName && (
                <IpPoolDialog
                    open={ipDialog}
                    platformReseller={platformReseller}
                    callbackClose={(): void => setIpDialog(false)}
                    callbackChangeIp={callBackSetIp}
                    apnNameId={apnNameId}
                    apnName={apnName}
                />
            )}
        </GridContainer>
    );
};
